import { fmtMoney, CURRENCY_SYMBOL } from "./movemap";

export { fmtMoney, CURRENCY_SYMBOL };

// Tipos de cuenta contable con su color.
export const ACCOUNT_TYPES = [
  { id: "activo", label: "Activo", color: "#10b981", hint: "Lo que tienes (Banco, Efectivo, Casa, Finca)" },
  { id: "pasivo", label: "Pasivo", color: "#f43f5e", hint: "Lo que debes (Deudas, Préstamos)" },
  { id: "capital", label: "Capital", color: "#6366f1", hint: "Patrimonio / aportes propios" },
  { id: "ingreso", label: "Ingreso", color: "#0ea5e9", hint: "Entradas (Ventas, Sueldo)" },
  { id: "gasto", label: "Gasto", color: "#f59e0b", hint: "Salidas (Comida, Servicios)" },
];

export function accountType(id) {
  return ACCOUNT_TYPES.find((t) => t.id === id) || ACCOUNT_TYPES[0];
}

// Convierte un monto a la moneda de visualización. rate = Bs por 1 $.
export function convert(amount, currency, displayCurrency, rate) {
  const a = Number(amount) || 0;
  if (currency === displayCurrency) return a;
  if (displayCurrency === "VES" && currency === "USD") return a * (rate || 0);
  if (displayCurrency === "USD" && currency === "VES") return rate ? a / rate : 0;
  return a;
}

// Calcula saldos por cuenta (en la moneda de visualización) y totales por tipo.
// Cada asiento resta del origen (from) y suma al destino (to).
export function computeLedger(accounts, entries, { displayCurrency = "USD", rate = 0 } = {}) {
  const balances = {};
  for (const acc of accounts) {
    balances[acc.id] = convert(acc.opening || 0, acc.currency || "USD", displayCurrency, rate);
  }
  for (const e of entries) {
    const amt = convert(e.amount || 0, e.currency || "USD", displayCurrency, rate);
    if (e.from && balances[e.from] !== undefined) balances[e.from] -= amt;
    if (e.to && balances[e.to] !== undefined) balances[e.to] += amt;
  }
  const byType = { activo: 0, pasivo: 0, capital: 0, ingreso: 0, gasto: 0 };
  for (const acc of accounts) {
    if (byType[acc.type] !== undefined) byType[acc.type] += balances[acc.id] || 0;
  }
  const patrimonio = byType.activo - byType.pasivo; // Activo − Pasivo
  const resultado = byType.ingreso - byType.gasto;   // Ingreso − Gasto
  return { balances, byType, patrimonio, resultado };
}
